var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataImportError } from "../Errors.js";
import { RadarDataSource } from "./RadarDataSource.js";
// Useful tool to cleanse manually created JSONs: https://jsonformatter.curiousconcept.com/#
export class JSONDataSource extends RadarDataSource {
    constructor(jsonFileURI) {
        super();
        this.jsonFileURI = jsonFileURI;
    }
    fetchData() {
        return __awaiter(this, void 0, void 0, function* () {
            let inputData;
            try {
                const response = yield fetch(this.jsonFileURI);
                if (!response.ok) {
                    throw ("Can't load json from\n" + response.url + "\nRequest status: " + response.status + " " + response.statusText);
                }
                inputData = yield response.json();
            }
            catch (error) {
                throw new DataImportError(error);
            }
            this.setRadarContent(inputData);
            return inputData;
        });
    }
}
//# sourceMappingURL=JSONDataSource.js.map